import { IEnvironments } from './model';

export const environments: IEnvironments = {
  dev: {
    env: 'dev',
    apiBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    apiFenxUrl: 'http://localhost:3000/api', // FENX API
    apiStaticBaseUrl: 'https://api-static-s3.staging.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'http://localhost:3000/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'dev', verbose: true },
  },
  'local.docker': {
    env: 'dev',
    apiBaseUrl: 'https://atlas.cluster.dev.tech.vestiairecollective.com/',
    apiFenxUrl: 'http://localhost:3000/api', // FENX API
    apiStaticBaseUrl: 'https://api-static-s3.staging.vestiairecollective.com',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'http://localhost:3000/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'dev', verbose: true },
  },
  stage: {
    env: 'stage',
    apiBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    apiFenxUrl: 'https://www.staging.vestiairecollective.com/api',
    apiStaticBaseUrl: 'https://api-static-s3.staging.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'https://www.staging.vestiairecollective.com/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'staging', verbose: true },
  },
  teod: {
    env: 'teod',
    apiBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    apiFenxUrl: 'https://www.staging.vestiairecollective.com/api',
    apiStaticBaseUrl: 'https://api-static-s3.staging.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'https://www.staging.vestiairecollective.com/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'teod', verbose: true },
  },
  qa: {
    env: 'qa',
    apiBaseUrl: 'https://apiv2.qa.vestiairecollective.com',
    apiFenxUrl: 'https://www.qa.vestiairecollective.com/api',
    apiStaticBaseUrl: 'https://api-static-s3.qa.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'https://www.qa.vestiairecollective.com/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'qa', verbose: true },
  },
  preprod: {
    env: 'preprod',
    apiBaseUrl: 'http://atlas.preprod.vestiairecollective.com',
    apiFenxUrl: 'https://www.staging.vestiairecollective.com/api',
    apiStaticBaseUrl: 'https://pp-api-static-s3.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAX2_IImeXCAj8iG',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-cg1rl0urvjmkgbfkqjf0cmkd32sicq1r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'https://www.staging.vestiairecollective.com/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: 'H5Ur9W865qxQrCKPbzY6',
    kakaoClientId: '456cf870279c813fd11962a53b2d8d0a',
    analytics: { envName: 'preprod', verbose: true },
  },
  production: {
    env: 'production',
    apiBaseUrl: 'https://apiv2.vestiairecollective.com',
    apiFenxUrl: 'https://www.vestiairecollective.com/api',
    apiStaticBaseUrl: 'https://api-static-s3.vestiairecollective.com/',
    captchaSiteKey: '0x4AAAAAAAYO6yitJf_jJb2r',
    facebookAppId: '93627932027',
    googleClientId: '127385984112-knuho0l08ieu704dbhv61q04887abb7r.apps.googleusercontent.com',
    appleClientId: 'com.vestiairedecopines.vcwebsignin',
    appleRedirectUri: 'https://www.vestiairecollective.com/api/auth/apple/callback',
    appleScope: 'name email',
    naverClientId: '2az1490zEiAr5udofRa6',
    kakaoClientId: '048001b4f4130334fac3cad9cb53485f',
    analytics: { envName: 'production', verbose: false },
  },
};
